//* Vue
import type { SetupContext } from "vue";

export const useComposable = (define: { top?: number; isTop: boolean }, emits: SetupContext<["returnTop"]>["emit"]) => {
    //* 插件
    const i18n = useI18n();

    //* 静态数据
    const vars = {
        insides: [
            { link: { name: "Tool" }, name: i18n.t("Toolbox") },
            { link: { name: "About" }, name: i18n.t("AboutTheSite") },
            { link: { name: "ContactUs" }, name: i18n.t("ContactUS") },
        ],

        blogrolls: [
            { link: "http://www.tsinghua-gd.org/", name: i18n.t("TsinghuaName") },
            { link: "https://www.cyagen.cn/", name: i18n.t("CyagenName") },
            { link: "https://www.zssy.com.cn/", name: i18n.t("SunYatSenName") },
        ],
    };

    //* 函数列表
    const methods = {
        return: () => {
            if (define.isTop) emits("returnTop");
            else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        },

        next: () => {
            open("https://space.bilibili.com/1553929661", "_blank");
        },
    };

    //* 计算属性
    const computeds = {
        styles: computed(() => {
            if (typeof define.top == "number" && define.top >= 0) return { marginTop: define.top + "px" };
            else {
                return {};
            }
        }),
    };

    return { vars, methods, computeds };
};
